export var TextBookConstants;
(function (TextBookConstants) {
    TextBookConstants["TEXT_BOOK_INFO"] = "TextBookInfo";
    TextBookConstants[TextBookConstants["MAX_GROUPS"] = 7] = "MAX_GROUPS";
    TextBookConstants[TextBookConstants["MAX_PAGES"] = 30] = "MAX_PAGES";
})(TextBookConstants || (TextBookConstants = {}));
export var groups = [1, 2, 3, 4, 5, 6];
export var colors = [
    'lightgreen',
    'lightskyblue',
    'yellow',
    'orange',
    'orangered',
    'red',
];
export var playAudio = function (arr) {
    setTimeout(function () {
        arr[0].play();
        setTimeout(function () {
            arr[1].play();
            setTimeout(function () {
                arr[2].play();
            }, arr[1].duration * 1000);
        }, arr[0].duration * 1000);
    });
};
